import { NotificationsService } from "./../activenotifications/notifications.service";
import { ConfirmdialogComponent } from "./../../dialogs/confirmdialog/confirmdialog.component";
import { AuthenticationService } from "./../../shared/authentication.service";
import { QuestionService } from "./../../shared/questionService";
import { RolesForSendingFeedback, QATicket, Question, QAResponse } from "./../../shared/qaTicket";
import { TicketService } from "./../../shared/ticketService";
import { Component, OnInit, Inject } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { SendFeedBack } from "../../shared/qaTicket";
import { LocalStorage } from "../../shared/localstorage.service";
import { InfodialogComponent } from "../../dialogs/infodialog/infodialog.component";

@Component({
  selector: "app-sendfeedbackbyrole",
  templateUrl: "./sendfeedbackbyrole.component.html",
  styleUrls: ["./sendfeedbackbyrole.component.scss"]
})

export class SendFeedbackByRoleComponent implements OnInit {

  notificationemails = new FormControl();
  emailList: string[] = [];
  notificationemaillist: string[] = [];
  excavatorFeedback: string = "";
  locationFeedback: string = "";
  mappingFeedback: string = "";
  notificationFeedback: string = "";
  remarksFeedback: string = "";
  endFeedBack: string = "";
  sendFeedbackText: string;
  rolesForUser: RolesForSendingFeedback;
  qaTicket = new QATicket();
  ticketQuestions = new Array<Question>();
  excavator = new Array<QAResponse>();
  notification = new Array<QAResponse>();
  location = new Array<QAResponse>();
  remarks = new Array<QAResponse>();
  map = new Array<QAResponse>();
  end = new Array<QAResponse>();

  constructor(public dialogRef: MatDialogRef<SendFeedbackByRoleComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public ticketService: TicketService,
    public questionService: QuestionService,
    public localStorage: LocalStorage,
    public notificationService: NotificationsService,
    public authService: AuthenticationService) { }


  ngOnInit() {
    this.questionService.getQATicket(this.data.gcTicketNumber, this.localStorage.getItem('currentState')).then(data => {
      if (data.QATicket != null) {
        this.qaTicket = data.QATicket;
        this.ticketQuestions = data.TicketQuestions;
        this.emailList = this.data.feedbackemaillist.split(',');
        this.excavatorFeedback = this.qaTicket.ExcavatorFeedback;
        this.locationFeedback = this.qaTicket.LocationFeedback;
        this.mappingFeedback = this.qaTicket.MappingFeedback;
        this.notificationFeedback = this.qaTicket.NotificationFeedback;
        this.remarksFeedback = this.qaTicket.RemarksFeedback;
        this.endFeedBack = this.qaTicket.EndFeedback;
        this.qaTicket.Response.forEach(response => {
          const question = this.ticketQuestions.find(x => x.ID === response.QuestionID);
          response.QuestionText = question.QuestionText;
          response.Section = question.Section;
          response.CanNA = question.CanNA;
        });

        this.qaTicket.Response.forEach(element => {
          if (element.Section === 0) {
            if (element.ResponseValue.toLowerCase() !== 'na') {
              if (element.ValidResponse.toLowerCase() === 'multiresponses' || 
              element.ResponseValue.toLowerCase() !== element.ValidResponse.toLowerCase()) {
                this.excavator.push(element);
              }
            }
          }
          if (element.Section === 1) {
            if (element.ResponseValue.toLowerCase() !== 'na') {
              if (element.ValidResponse.toLowerCase() === 'multiresponses' || 
              element.ResponseValue.toLowerCase() !== element.ValidResponse.toLowerCase()) {
                this.notification.push(element);
              }
            }
          }
          if (element.Section === 2) {
            if (element.ResponseValue.toLowerCase() !== 'na') {
              if (element.ValidResponse.toLowerCase() === 'multiresponses' || 
              element.ResponseValue.toLowerCase() !== element.ValidResponse.toLowerCase()) {
                this.location.push(element);
              }
            }
          }
          if (element.Section === 3) {
            if (element.ResponseValue.toLowerCase() !== 'na') {
              if (element.ValidResponse.toLowerCase() === 'multiresponses' || 
              element.ResponseValue.toLowerCase() !== element.ValidResponse.toLowerCase()) {
                this.remarks.push(element);
              }
            }
          }
          if (element.Section === 4) {
            if (element.ResponseValue.toLowerCase() !== 'na') {
              if (element.ValidResponse.toLowerCase() === 'multiresponses' || 
              element.ResponseValue.toLowerCase() !== element.ValidResponse.toLowerCase()) {
                this.map.push(element);
              }
            }
          }
          if (element.Section === 5) {
            if (element.ResponseValue.toLowerCase() !== 'na') {
              if (element.ValidResponse.toLowerCase() === 'multiresponses' || 
              element.ResponseValue.toLowerCase() !== element.ValidResponse.toLowerCase()) {
                this.end.push(element);
              }
            }
          }
        });
        console.log(this.end.length);
      }
    });
  }

  OnOkClick() {
    var sendFeedBackObj = new SendFeedBack();
    sendFeedBackObj.SendFeedBackText = this.sendFeedbackText;
    sendFeedBackObj.SendFeedBackTo = this.emailList;
    sendFeedBackObj.QARole = this.authService.role;

    this.dialogRef.close(sendFeedBackObj);
  }
  OnCancelClick() {
    this.dialogRef.close('cancel');
  }
  OnSuspendClick() {
    this.dialogRef.close('nosave');
  }
}

  // addToList() {
  //   if (!this.panel.expanded) {
  //     this.panel.expanded = true;
  //   }
  //   if (this.sendToEmail !== null && this.sendToEmail !== " " && this.sendToEmail !== "") {
  //     this.sendToEmailList.push({SendFeedBackEmail: this.sendToEmail, TemplateType: "Internal"});
  //   }
  //   this.sendToEmail = "";
  // }
